import { AlertController, LoadingController, Platform } from "@ionic/angular";
import { AuthService } from "./services/auth.service";
import { Component, OnInit } from "@angular/core";
import { CrudService } from "./services/crud.service";
import { loadingProps } from "src/utils/util.functions";
import { LocalNotifications } from "@capacitor/local-notifications";
import { ActivatedRoute, Router } from "@angular/router";
import { SignalRService } from "./services/signalr.service";
import { User, UserType } from "src/models/user.model";
import { Observable, Subscriber, Subscription, TeardownLogic } from "rxjs";
import { Storage } from "@ionic/storage-angular";
import { Events } from "./services/events-service.service";
import { MapsService } from "./services/maps.service";
import { Capacitor } from "@capacitor/core";
import { SplashScreen } from "@capacitor/splash-screen";
import { App } from "@capacitor/app";
import { register } from "swiper/element/bundle";

register();
@Component({
    selector: "app-root",
    templateUrl: "app.component.html",
    standalone: false
})
export class AppComponent implements OnInit {
  user: User;
  driverIsInLine = false;
  dataClient: any;
  modalLink = false;
  userType = UserType;
  public appPages = [];
  public appSections: { header: string; items: any[] }[] = [];
  pathFolderPlayer2 = "assets/sounds/alarm.mp3";
  private alarmAudio: HTMLAudioElement;
  public pagesCaller = [
    {
      title: "Dashboard",
      url: "/call/dashboard",
      icon: "apps",
      permission: [UserType.Caller],
      section: "RIDES",
    },
    {
      title: "Book a Ride",
      url: "/call/call-driver",
      icon: "car",
      permission: [UserType.Caller, UserType.Driver],
      section: "RIDES",
    },
    {
      title: "Trip Check out",
      url: "/call/trip-checkout",
      icon: "cart-outline",
      permission: [UserType.Caller],
      section: "RIDES",
    },
    {
      title: "Trip History",
      url: "/call/history-races",
      icon: "list",
      permission: [UserType.Caller, UserType.Driver],
      section: "RIDES",
    },
    {
      title: "Scheduled Trip Requests",
      url: "/call/scheduled-trips",
      icon: "alarm",
      permission: [UserType.Caller, UserType.Driver],
      section: "RIDES",
    },
    {
      title: "Services",
      icon: "restaurant-spread",
      url: "/call/restaurants-booking",
      permission: [UserType.Caller],
      section: "SERVICES",
    },
    {
      title: "Service History",
      url: "/call/history-restaurants",
      icon: "list-outline",
      section: "SERVICES",
    },
    {
      title: "Brochure History",
      url: "/call/history-brochures",
      icon: "book",
      permission: [UserType.Caller],
      section: "SERVICES",
    },
    {
      title: "Spread",
      icon: "person",
      url: "/call/seller-registration",
      permission: [UserType.Caller],
      section: "SPREADER TOOLS",
      detail: true,
    },
    {
      title: "Guest Link",
      icon: "link",
      url: "#",
      permission: [UserType.Caller],
      section: "SPREADER TOOLS",
      detail: true,
    },
    {
      title: "Redeem Points",
      url: "/call/points-withdrawal",
      icon: "ribbon",
      permission: [UserType.Caller],
      section: "SPREADER TOOLS",
    },
    {
      title: "Earnings",
      url: "/call/balance-driver",
      icon: "logo-usd",
      section: "ACCOUNT",
    },
    {
      title: "Notifications",
      icon: "notifications",
      url: "/notifications",
      permission: [UserType.Caller, UserType.Driver, UserType.Restaurant],
      section: "ACCOUNT",
    },
    {
      title: "Logout",
      url: "/",
      icon: "log-out",
      permission: [UserType.Caller, UserType.Driver],
      section: "ACCOUNT",
    },
  ];

  public pagesClient = [];

  private buildSections(pages: any[]) {
    const map = new Map<string, any[]>();
    for (const page of pages) {
      const section = page.section || '';
      if (!map.has(section)) map.set(section, []);
      map.get(section).push(page);
    }
    this.appSections = Array.from(map.entries()).map(([header, items]) => ({ header, items }));
  }

  public pagesDriver = [
    {
      title: "Dashboard",
      url: "/driver/queue",
      icon: "home",
    },
    {
      title: "Trip History",
      url: "/call/history-races",
      icon: "list",
    },
    {
      title: "Scheduled Trip Requests",
      url: "/call/scheduled-trips",
      icon: "alarm",
      permission: [UserType.Caller, UserType.Driver],
    },
    {
      title: "Records",
      url: "/call/balance-driver",
      icon: "logo-usd",
    },
    {
      title: "Payout Methods",
      url: "/driver/payment-methods",
      icon: "card",
    },
    {
      title: "Logout",
      url: "/",
      icon: "log-out",
    },
  ];

  public pagesRestaurant = [
    {
      title: "Reservation Requests",
      url: "/call/reservations-requests",
      icon: "home",
    },
    {
      title: "My Services",
      url: "/call/history-restaurants",
      icon: "restaurant-spread",
    },
    {
      title: "Notifications",
      url: "/notifications",
      icon: "notifications",
    },
    {
      title: "Records",
      url: "/call/balance-driver",
      icon: "logo-usd",
    },
    {
      title: "Logout",
      url: "/",
      icon: "log-out",
    },
  ];
  locationSubscription: Subscription;
  headingSubscription: Subscription;
  scheduledInterval: NodeJS.Timeout;

  constructor(
    private platform: Platform,
    private auth: AuthService,
    private signalRService: SignalRService,
    private router: Router,
    private route: ActivatedRoute,
    private loadingCtrl: LoadingController,
    private alertController: AlertController,
    private _crudService: CrudService,
    public events: Events,
    private storage: Storage,
    private _mapsService: MapsService
  ) {}
  async ngOnInit() {
    await this.initializeApp();
    this.dataClient = JSON.parse(sessionStorage.getItem("dataClient"));
  }

  async actionItem(item) {
    if (item.title === "Logout") {
      await this.logout();
    } else if (item.title === "Dashboard") {
      if (this.user.userType === this.userType.Caller) {
        await this.router.navigate(["call", "dashboard"]);
      } else {
        if (this.driverIsInLine) {
          await this.router.navigate(["driver", "information-queue"]);
        } else {
          await this.router.navigate(["driver", "queue"]);
        }
      }
    } else if (item.title === "Guest Link") {
      this.openModelLink();
    } else {
      await this.navigate(item);
    }
  }

  async navigate(item) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    await this.router.navigate([item.url]);
  }

  openModelLink(): void {
    this.modalLink = true;
  }

  setStatusModalLink() {}

  private async logout() {
    localStorage.clear();
    await this.storage.clear();
    await this.router.navigate([""]);
    if (Capacitor.isNativePlatform()) {
      // Background geolocation stop is handled by Capacitor geolocation watch cleanup
    }
    if (this.locationSubscription) this.locationSubscription.unsubscribe();
    if (this.headingSubscription) this.headingSubscription.unsubscribe();
    await this.auth.logoutUser();
    await this.disconnectFromSignalR();
    await this.clearTimers();
  }

  private async clearTimers() {
    await new Promise((resolve, reject) => {
      for (let index = 1000; index >= 0; index--) {
        clearTimeout(index);
        clearInterval(index);
      }
      resolve(true);
      reject(false);
    });
  }

  private async disconnectFromSignalR() {
    if (
      this.user.userType === this.userType.Driver ||
      this.user.userType === this.userType.Caller
    ) {
      await this.leaveLine();
      await this.signalRService.disconnect();
      this.signalRService.clearHub();
      this.events.publish("clearQueueInterval");
    }
  }

  async showLoading() {
    loadingProps.mode = this.platform.is("ios") ? "ios" : "md";
    const loading = await this.loadingCtrl.create(loadingProps);
    return await loading.present();
  }
  async leaveLineAcceptedRace() {
    await this.showLoading();
    const currentPage = this.router.url;
    if (currentPage !== "/driver/queue") {
      // Wake lock is released by the info-queue page on leave
      await this.dismissLoad();
    } else {
      setTimeout(async () => {}, 600);
    }
    await this.dismissLoad();
  }
  async leaveLine() {
    clearInterval(this.scheduledInterval);
    await this.signalRService.setLeaveLine(null);
    await this.dismissLoad();
  }

  async notificationHandler(upcomingRaceNotification) {
    const url = this.router.url;
    console.log(url);
    if (url.includes("driver/start") || url.includes("driver/current-race")) {
      return;
    }
    localStorage.setItem(
      "currentRace",
      JSON.stringify(upcomingRaceNotification)
    );
    switch (url) {
      case "/driver/information-queue":
      case "/call/call-driver":
        await this.router.navigate(["driver", "queue"]);
        break;
      default:
        break;
    }
    const dataAgendamento = new Date(
      upcomingRaceNotification.dataAgendamentoCorrida
    );
    const dataAtual = new Date();
    const diffMinutes = Math.round(
      (dataAgendamento.getTime() - dataAtual.getTime()) / 60000
    );
    const wasNotifiedFifteenMinutes = localStorage.getItem(
      `${upcomingRaceNotification.id}`
    );
    console.log(wasNotifiedFifteenMinutes);
    if (diffMinutes >= 15 && wasNotifiedFifteenMinutes !== "true") {
      localStorage.setItem(`notified_${upcomingRaceNotification.id}`, "true");
      this.showUpcomingTripNotification(upcomingRaceNotification);
      const alert = await this.showUpcomingTripAlert(upcomingRaceNotification);
      await alert.present();
      await this.leaveLineAcceptedRace();
    } else {
      localStorage.setItem(`notified_${upcomingRaceNotification.id}`, "false");
    }
  }
  async enableScheduledCalls() {
    await this.signalRService.getUpcomingRaceNotification(
      async (upcomingRaceNotification) => {
        await this.notificationHandler(upcomingRaceNotification);
      }
    );

    this.scheduledInterval = setInterval(async () => {
      this._crudService.postData("Corrida/proxima-corrida-driver").subscribe(
        async (response: any) => {
          if (response?.success) {
            const trip = response.data;
            if (!trip) return;
            await this.notificationHandler(trip);
          }
        },
        async (error) => {
          console.log(error);
        }
      );
    }, 240000);
  }
  private async showUpcomingTripAlert(upcomingRaceNotification: any) {
    const url = this.router.url;
    console.log("showUpcomingTripAlert");
    console.log(url);
    if (await this.alertController.getTop())
      await this.alertController.dismiss();
    return await this.alertController.create({
      mode: this.platform.is("ios") ? "ios" : "md",
      header: `Your upcoming trip to ${upcomingRaceNotification.enderecoDestino} will be soon.`,
      message: `Go to ${
        upcomingRaceNotification.enderecoOrigem
      } to start trip for ${new Date(
        upcomingRaceNotification.dataAgendamentoCorrida
      ).toLocaleString("en-US", {
        hour12: true,
      })}`,
      buttons: [
        "Cancel",
        {
          text: "Go to trip",
          handler: async () => {
            this._crudService
              .postData("sms/send-sms", null, {
                numeroDestinatario: upcomingRaceNotification.celular,
                mensagem:
                  `Your driver ${upcomingRaceNotification.motorista.nome} is on the way. ` +
                  `Car: ${upcomingRaceNotification.motorista.veiculo.marca} ` +
                  `${upcomingRaceNotification.motorista.veiculo.modelo}. ` +
                  `License plate: ${upcomingRaceNotification.motorista.veiculo.placa} ` +
                  `Color: ${upcomingRaceNotification.motorista.veiculo.cor}`,
              })
              .subscribe(
                () => {},
                () => {}
              );
            await this.signalRService.setLeaveLine(null);
            await this.router.navigate(["/driver", "start"], {
              relativeTo: this.route,
              skipLocationChange: true,
            });
            await this.dismissLoad();
          },
        },
      ],
    });
  }

  private showUpcomingTripNotification(upcomingRaceNotification: any) {
    if (Capacitor.isNativePlatform()) {
      LocalNotifications.schedule({
        notifications: [{
          title: `Your upcoming trip to ${upcomingRaceNotification.enderecoDestino} will be soon.`,
          body: `Go to ${
            upcomingRaceNotification.enderecoOrigem
          } to start trip for ${new Date(
            upcomingRaceNotification.dataAgendamentoCorrida
          ).toLocaleString("en-US", {
            hour12: true,
          })}`,
          id: new Date(upcomingRaceNotification.dataAgendamentoCorrida).getTime(),
          schedule: { at: new Date(Date.now() + 1000) },
          sound: null,
          attachments: null,
          actionTypeId: "",
          extra: null,
        }]
      }).catch(console.error);

      LocalNotifications.addListener("localNotificationActionPerformed", async (event) => {
        this._crudService
          .postData("sms/send-sms", null, {
            numeroDestinatario: upcomingRaceNotification.celular,
            mensagem:
              `Your driver ${upcomingRaceNotification.motorista.nome} is on the way. ` +
              `Car: ${upcomingRaceNotification.motorista.veiculo.marca} ${upcomingRaceNotification.motorista.veiculo.modelo}. License plate: ${upcomingRaceNotification.motorista.veiculo.placa} ` +
              `Color: ${upcomingRaceNotification.motorista.veiculo.cor}`,
          })
          .subscribe(
            () => {},
            () => {}
          );
        const id = event.notification.id;
        await this.signalRService.setLeaveLine(null);
        await this.router.navigate(["/driver", "start"], {
          relativeTo: this.route,
          skipLocationChange: true,
        });
        await this.dismissLoad();
        localStorage.removeItem(id.toString());
      });
    }
  }

  async initializeApp() {
    this.platform.ready().then(async (readySource) => {
      if (Capacitor.isNativePlatform()) {
        SplashScreen.hide({ fadeOutDuration: 300 }).catch(() => {});
      }
      await this.storage.create();
      await this._mapsService.loadGoogleMaps();
      this.user = await this.auth.dataAuth();
      localStorage.clear();

      this.events.subscribe("enableScheduledCalls", async () => {
        await this.enableScheduledCalls();
      });
      this.events.subscribe("enterLine", (status: boolean) => {
        this.driverIsInLine = status;
      });
      this.events.subscribe("openGuestLink", () => {
        this.openModelLink();
      });

      if (this.auth.user) {
        if (this.auth.user.userType === UserType.Caller) {
          this.appPages = this.pagesCaller;
          this.buildSections(this.pagesCaller);
        } else if (this.auth.user.userType === UserType.Driver) {
          this.locationSubscription = this.watchPosition({
            enableHighAccuracy: true,
          }).subscribe(
            async (position) => {
              this._crudService
                .patchData(`motorista/update-location/`, {
                  motoristaId: this.auth.user.id,
                  latitude: position.coords.latitude,
                  longitude: position.coords.longitude,
                  heading: position.coords.heading ?? 0,
                })
                .subscribe(
                  () => {},
                  () => {}
                );
            },
            async (error) => {}
          );
          this.appPages = this.pagesDriver;
          this.buildSections(this.pagesDriver);
        } else if (this.auth.user.userType === UserType.Restaurant) {
          this.appPages = this.pagesRestaurant;
          this.buildSections(this.pagesRestaurant);
        }

        if (this.dataClient) {
          this.appPages = this.pagesClient;
        }
      }

      this.auth.$controlAuth.subscribe((user) => {
        if (user) {
          if (user.userType === UserType.Caller) {
            this.appPages = this.pagesCaller;
            this.buildSections(this.pagesCaller);
          } else if (this.auth.user.userType === UserType.Driver) {
            this.appPages = this.pagesDriver;
            this.buildSections(this.pagesDriver);
          } else if (this.auth.user.userType === UserType.Restaurant) {
            this.appPages = this.pagesRestaurant;
            this.buildSections(this.pagesRestaurant);
          }

          this.user = user;

          if (this.dataClient) {
            this.appPages = this.pagesClient;
            this.buildSections(this.pagesClient);
          }
        }
      });

      await this.initializeNativePlugins(readySource);

      // Set up app state listener for SignalR lifecycle management
      if (Capacitor.isNativePlatform()) {
        App.addListener("appStateChange", ({ isActive }) => {
          if (!isActive) {
            // App went to background - SignalR handles reconnection automatically
          }
        });
      }
    });
  }

  private async initializeNativePlugins(readySource: string) {
    if (Capacitor.isNativePlatform()) {
      // Preload alarm audio using HTML5 Audio API (replaces NativeAudio)
      this.alarmAudio = new Audio(this.pathFolderPlayer2);
      this.alarmAudio.load();
    }
  }

  private async dismissLoad() {
    if (await this.loadingCtrl.getTop()) {
      await this.loadingCtrl.dismiss();
    }
  }
  private watchPosition(options?: PositionOptions): Observable<GeolocationPosition> {
    return new Observable<GeolocationPosition>(
      (subscriber: Subscriber<GeolocationPosition>): TeardownLogic => {
        const watchId = navigator.geolocation.watchPosition(
          subscriber.next.bind(subscriber),
          subscriber.error.bind(subscriber),
          options
        );
        return (): void => {
          navigator.geolocation.clearWatch(watchId);
        };
      }
    );
  }
}
